var n = (e, o, r) => new Promise((p, a) => {
  var c = (t) => {
    try {
      s(r.next(t));
    } catch (i) {
      a(i);
    }
  }, g = (t) => {
    try {
      s(r.throw(t));
    } catch (i) {
      a(i);
    }
  }, s = (t) => t.done ? p(t.value) : Promise.resolve(t.value).then(c, g);
  s((r = r.apply(e, o)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function l(e) {
  return n(this, null, function* () {
    const {
      data: o
    } = yield d.post(
      "/designordercenter/productionOrder/specialApply/getOrgPageListByQry",
      e
    );
    return o;
  });
}
export {
  l as postGetOrgPageList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/getOrgPageList/post.js
// module id = 1778
// module chunks = 41